import React from 'react';
import { LoyaltyWelcomeCard as LoyaltyBenefitsComponent } from '@thd-olt-component-react/loyalty-benefits';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import './loyalty-benefits_override.scss';
export var LoyaltyBenefits = function () {
    return (React.createElement(ErrorBoundary, { name: "loyalty-benefits" },
        React.createElement("div", { className: "overrides" },
            React.createElement(LoyaltyBenefitsComponent, null))));
};
